import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { processGoogleCallback } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (sessionId) {
      processGoogleCallback(sessionId)
        .then((data) => {
          if (process.env.NODE_ENV !== 'production') {
            console.log('[AuthCallback] Google login success:', { is_platform_operator: data?.is_platform_operator, has_token: !!data?.token, role: data?.role, email: data?.email });
          }
          // Use full page redirect to ensure auth state is fresh
          const dest = data?.is_platform_operator ? '/dev-hub' : '/';
          window.location.replace(dest);
        })
        .catch((err) => {
          console.error('[AuthCallback] Google login FAILED:', err?.response?.data || err?.message || err);
          navigate('/login', { replace: true });
        });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate, processGoogleCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto" />
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
}
